const MySharedAssetsColumn = [
    {
        id: "name",
        label: "Name",
        type: "name",
        style: { custom: { width: "calc(100% - 732px)", pl: 1.5 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "project",
        label: "Project",
        type: "project",
        style: { custom: { width: 176 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "expiresAt",
        label: "Share expiration date",
        type: "expireDate",
        style: { custom: { width: 136 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "downloadsRemaining",
        label: "Number of downloads remaining",
        type: "downloadsRemaining",
        style: { custom: { width: 160 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "shared",
        label: "Share date",
        type: "date",
        style: { custom: { width: 140 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "shared",
        label: "Sharer",
        type: "user",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

const MySharingAssetsColumn = [
    {
        id: "name",
        label: "Name",
        type: "name",
        style: { custom: { width: "calc(100% - 176px)", pl: 1.5 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "project",
        label: "Project",
        type: "project",
        style: { custom: { width: 176 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];
export { MySharedAssetsColumn, MySharingAssetsColumn };
